import FLAG from 'config/flag.singleton';
import { AUTH_API } from 'middleware/api';
import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('actionOldBe'); // eslint-disable-line no-unused-vars

const actionOldBe = (fn) => {
  if (isNotFn(fn)) L.error('()', 'Not a function:', fn);

  // noinspection UnnecessaryLocalVariableJS
  const actionOldBeWrapper = (...args) => {
    const object = fn(...args);

    if (FLAG.loggerSpam) L.debug('()', object?.config?.method, object?.endpoint, '|', object);

    return { [AUTH_API]: object };
  };

  return actionOldBeWrapper;
};

export default actionOldBe;
